import React, { useEffect, useState } from "react";
import SidebarApp from "../components/get-conversation/getConversation";
import "./MainPage.css";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import "../../../../src/ColorTheme.css";
import "./LandingPage.css";
import {
  useGetAppSuiteCosts,
  useGetAvailablePackages,
  useGetCreditPackages,
  useGetUserCredits,
  usePopularQuestionsAnswers,
} from "../../../store/Apis/StripeApi";
import { useGetDefaultModelMode } from "../../../store/Apis/ChatModelApi";
import {
  getChatsOpen,
  setDefaultModelMode,
  setFileError,
} from "../../../store/one-query/chatsSlice";
import { LandingPage } from "../../landing-page/Views/LandingPage";
import useNavigateToMainPage from "../../../NavigateToMainPage";
import { useGetPromptLibraryRequest } from "../../../store/Apis/PromptLibraryApi";
import { setPromptLibraryItems } from "../../../store/one-query/promptLibrarySlice";
import { AppViewType, DefaultModelsNumber } from "../../../Helper";
import Navbar from "../components/get-conversation/Navbar";
import { setPackageCredits, signinUserSuccess } from "../../../store/account/userSlice";
import { Outlet, useNavigate } from "react-router-dom";

function HomePage() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isAuthenticated = useAppSelector((s) => s.User.IsAuthenticated);
  const ChatsState = useAppSelector((state) => state.ChatsState);
  const { getSubscribePackages } = useGetAvailablePackages();
  const {data:getAllAvailablePackages,refetch:getCreditsPackages}=useGetCreditPackages()
  const getUserCredits=useGetUserCredits();
  const getAppSuiteCosts=useGetAppSuiteCosts();
  const { getFQuestionsAndAnswers } = usePopularQuestionsAnswers();
  const { data: defaultModelModeRequestData } = useGetDefaultModelMode();
  const navigateToMainPage = useNavigateToMainPage();
  const {
    data: PromptLibraryData,
    isSuccess,
    refetch: getPromptItemsRequest,
  } = useGetPromptLibraryRequest();
  const [canSetActiveModels, SetCanSetActiveModels] = useState<boolean>();
  const [showClosedChatsModeModal, setShowClosedChatsModeModal] =
    useState(false);
  const [currentAppView, setCurrentAppView] = useState<number>(
    AppViewType.MainPage
  );

  const params = new URLSearchParams(location.search);

  let token = params.get("token");
  useEffect(()=>{
    if(isAuthenticated)
      getCreditsPackages();
  },[isAuthenticated])
   useEffect(()=>{
    if(getAllAvailablePackages)
        dispatch(setPackageCredits(getAllAvailablePackages));
   },[getAllAvailablePackages])
  // handle user sign in with external apps
  useEffect(() => {
    const data: any = {
      token: params.get("token"),
      userData: {
        profilePictureURL: params.get("profile"),
        userName: params.get("userName"),
        email: params.get("email"),
        id: params.get("userId"),
        firstName: params.get("firstName"),
        lastName: params.get("lastName"),
        mode: params.get("mode"),
        isSigned: params.get("isSigned"),
        isSubscriped: params.get("isSubscriped")?.toLowerCase() === "true",
        hasAnySubscriptions: params.get("hasAnySubscriptions"),
      },
    };
    if (data) {
      if (data?.token?.length > 0 && data.userData.isSigned) {
        const workflowSharedLink = sessionStorage.getItem("redirectAfterLogin");
        dispatch(
          signinUserSuccess({
            IsAuthenticated: true,
            token: data?.token,
            userData: data?.userData,
          })
        );
        //Check if there workflow shared link , if there navigate to it after login with external apps.
        if (workflowSharedLink) {
          navigate(workflowSharedLink)
          sessionStorage.removeItem("redirectAfterLogin")
        } else {
          navigateToMainPage();
        }
      } else if (data?.token?.length === 0) {
        if (data.userData.mode === "login") {
          navigateToMainPage();
          dispatch(
            setFileError({
              isError: true,
              errorMsg: "This email doesn't exist please register",
              reason: "user upload file type not support",
            })
          );
        } else if (data.userData.mode === "register") {
          navigateToMainPage();
          dispatch(
            setFileError({
              isError: true,
              errorMsg: "This email already exist please sign in",
              reason: "user upload file type not support",
            })
          );
        }
      }
    }
  }, [location.search]);

  useEffect(() => {
    // Get prompt library endpoint.
    if (isSuccess) {
      dispatch(setPromptLibraryItems(PromptLibraryData));
    }
  }, [isSuccess]);

  useEffect(() => {
    // Get payment cost & url.
    if (isAuthenticated || token) {
      getSubscribePackages();
      getFQuestionsAndAnswers();
      getUserCredits();
      getAppSuiteCosts();
    }
    getPromptItemsRequest();
  }, []);

  useEffect(() => {
    // Get default model mode endpoint.
    if (defaultModelModeRequestData)
      dispatch(setDefaultModelMode(defaultModelModeRequestData));
  }, [defaultModelModeRequestData]);

  // useEffect to set the default model mode.
  useEffect(() => {
    if (ChatsState.newConversation && ChatsState.defaultModelMode.length > 0) {
      const defaultModelModeObj = ChatsState.defaultModelMode.find(
        (obj) => obj.isDefault === true
      );
      const defaultModelNames = Object.values(defaultModelModeObj || {}).filter(
        (value) => typeof value === "string" && value !== null
      );
      const modelMode =
        `Mode${defaultModelModeObj?.mode}` as keyof typeof DefaultModelsNumber;

      if (modelMode) {
        dispatch(
          getChatsOpen({
            chatsNum: DefaultModelsNumber[modelMode],
            selectedOptions: defaultModelNames,
          })
        );
      }
    }
  }, [ChatsState.defaultModelMode, ChatsState.newConversation]);

  // useEffect to set the default models when swap between modes.
  useEffect(() => {
    if (ChatsState.newConversation) {
      const defaultModelModels = ChatsState.defaultModelMode.find(
        (model) =>
          DefaultModelsNumber[
            `Mode${model.mode}` as keyof typeof DefaultModelsNumber
          ] === ChatsState.chatsNum
      );
      if (defaultModelModels) {
        const modelMode =
          `Mode${defaultModelModels.mode}` as keyof typeof DefaultModelsNumber;
        const defaultModelNames = Object.values(
          defaultModelModels || {}
        ).filter((value) => typeof value === "string" && value !== null);
        dispatch(
          getChatsOpen({
            chatsNum: DefaultModelsNumber[modelMode],
            selectedOptions: defaultModelNames,
          })
        );
      }
      navigateToMainPage();
    }
  }, [ChatsState.chatsNum]);

  return (
    <div className={`d-flex ${isAuthenticated ? "home-page" : "LandingPage"}`}>
     
      {isAuthenticated || token ? (
        <>
          <SidebarApp />
          <div className="flex-grow-1">
            <Navbar
              setShowClosedChatsModeModal={setShowClosedChatsModeModal}
              showClosedChatsModeModal={showClosedChatsModeModal}
            />
            <Outlet />
          </div>
        </>
      ) : (
        <LandingPage />
      )}
    </div>
  );
}
// i need make style component

export default HomePage;
